<template>
    <v-container fluid style=""> 
    
     <v-row>
        <v-spacer></v-spacer>
        <v-btn style=" font-size: 0.9em; font-weight: 400;" color="#185EA9" text @click="onAddColumn()"  >Añadir columna</v-btn>
    </v-row>
    <v-row > 
       <v-data-table :disableFiltering="true" style="width:100%; margin: 0;"
             :headers="headers" :class="'row-pointer'"
             ref = "dataTable"
             :items="data" 
             :fixedHeader="true" 
             :height="tableHeight"
             @click:row="col => onEditColumn(col)"
         >
     
         </v-data-table>
      </v-row>

      <v-dialog v-model="editDialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            Editar columna
          </v-card-title>
          <v-card-text>
            <v-form ref="columnForm">
              <v-row style="width:100%; margin: 0;">
                <v-col cols="6">
                    <v-text-field
                        v-model="editColumn.field"
                        :label="'Field'" :rules="[validationRules.required]"
                        autocomplete="none"
                        max="300"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="editColumn.label"
                        :label="'Label'" :rules="[validationRules.required]"
                        :hint="$t(editColumn.label)" persistent-hint
                        autocomplete="none"
                        max="300"
                    />
                </v-col>
                <v-col cols="12">
                    <v-select
                        v-model="editColumn.formatter"
                        :label="'Formatter'" clearable
                        :items="formatters"
                    />
                </v-col>
            </v-row>
            </v-form>

            <v-row v-if="editColumn.formatter && editColumn.formatter=='formatChoice'" style="width:100%; margin: 0;">
                <v-form ref="choicesForm">
                     <v-row>
                    <v-spacer></v-spacer>
                    <v-btn style=" font-size: 0.9em; font-weight: 400;" color="#185EA9" text @click="onAddChoice()"  >Añadir opción</v-btn>
                </v-row>
                <v-col cols="12" v-for="(item, index) in editColumn.choices" :key="index">
                    <v-row >
                            <v-col cols="5">
                            <v-text-field
                                v-model="item.key"
                                :label="'Key'" :rules="[validationRules.required]"
                                autocomplete="none"
                                max="300"
                            />
                        </v-col>
                        <v-col cols="5">
                            <v-text-field
                                v-model="item.value"
                                :label="'Value'" :rules="[validationRules.required]"
                                autocomplete="none"
                                max="300"
                            />
                        </v-col>
                        <v-col cols="2" >
                            <v-btn @click="onDeleteChoice(item)" class="mt-4" color="primary" dark v-bind="attrs" v-on="on" text>
                                <v-icon small>delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                </v-form>
            </v-row>
          </v-card-text> 
          <v-card-actions>
            <v-btn v-if="editedIndex>-1" color="#ff0000" @click="onDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="onCancelEdit()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
 
     </v-container>
 </template>
 
 <script> 
 
 import BaseModule from '../../../common/BaseModule.js'
 import { Constants } from '../../../common/Constants'

 export default {
   name: 'ColumnEditor',
   mixins: [BaseModule],
   components: { 
    
   },
    props: ['columns'],
   
   data() {
       return {
         headers: [{ text: 'Field', value: 'field' },
                    { text: 'Label', value: 'label' },
                    { text: 'Formatter', value: 'formatter' },],
         data: [],
         editedIndex: -1,
         editColumn: {},
         tableHeight:300,
         formatters:[],
         editDialog: false
       }
   }, mounted() {
        this.data = this.columns?this.columns:[];
        this.formatters = Constants.formatters;
    },watch: {
       context: function() { 
        
      },
      columns: function(columns) { 
        this.data = columns?columns:[];
    }
     },
    methods: { 
        onAddColumn() {
            this.editedIndex = -1;
            this.editDialog=true;
            this.editColumn = {};
        },
        onAddChoice() {
            if (!this.editColumn.choices) {
                this.editColumn.choices =  [];
            }
            this.editColumn.choices.push({key:'', value:''});
        },
        onEditColumn(column) {
            this.editedIndex = this.data.indexOf(column);
            this.editDialog=true;
            this.editColumn =  Object.assign({}, column);
        },
        onCancelEdit() {
            this.editDialog=false;
            this.editColumn = {};
        },
        onDelete () {
            this.data.splice(this.editedIndex, 1)
            this.editDialog=false;
            this.editColumn = {};
        },onDeleteChoice (item) {
            this.editColumn.choices.splice(this.editColumn.choices.indexOf(item), 1);
        },
        onSave() {
            if ((this.$refs.choicesForm && !this.$refs.choicesForm.validate())|| !this.$refs.columnForm.validate()) {
					return;
			}

            if (this.editedIndex > -1) {
                Object.assign(this.data[this.editedIndex], this.editColumn)
            } else {
                this.data.push(this.editColumn)
            }

            this.editDialog=false;
            this.editColumn = {};
        }
    }
 };
 </script>
  